import styled from '@emotion/styled'
import React from 'react'

const AvatarPreview=styled('div')({
    height:'42px',
    width:'42px',
    backgroundColor:'#f97316',
    borderRadius:'42px',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontSize:'16px',
    fontWeight:'800',
    marginLeft:'5px',
    color:'white',
    backgroundSize:'cover',
    backgroundPosition:'center',
    flexShrink:0,
})

const Avatar = ({username,displayName,avatarUrl,large,small}) => {
  const name = displayName || username || "?";
  return (
    <AvatarPreview
      style={{
        ...(large ? {height:'60px',width:'60px',fontSize:'20px'} : {}),
        ...(small ? {height:'28px',width:'28px',fontSize:'12px',marginLeft:0} : {}),
        ...(avatarUrl ? {backgroundImage:`url(${avatarUrl})`, color:"transparent"} : {}),
      }}
    >
      {!avatarUrl && name.substring(0,2)}
    </AvatarPreview>
  )
}

export default Avatar
